import { Area, AreaChart, ResponsiveContainer, YAxis } from "recharts";

interface SparklineProps {
  /** Ordered series, oldest → newest. */
  data: number[];
  width?: number;
  height?: number;
  className?: string;
}

/** Tiny inline trend chart for a table cell. No axes, no tooltip — just the
 *  shape of a numeric series over time. Renders nothing meaningful for an
 *  all-zero series (flat line at baseline), which is the intended "quiet org"
 *  look. */
export function Sparkline({ data, width = 96, height = 28, className }: SparklineProps) {
  const points = data.map((v, i) => ({ i, v }));
  const hasSignal = data.some((v) => v > 0);

  return (
    <div className={className} style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={points} margin={{ top: 2, right: 0, bottom: 2, left: 0 }}>
          <defs>
            <linearGradient id="sparkFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="currentColor" stopOpacity={0.35} />
              <stop offset="100%" stopColor="currentColor" stopOpacity={0} />
            </linearGradient>
          </defs>
          <YAxis hide domain={[0, "dataMax"]} />
          <Area
            type="monotone"
            dataKey="v"
            stroke="currentColor"
            strokeWidth={1.5}
            fill={hasSignal ? "url(#sparkFill)" : "transparent"}
            isAnimationActive={false}
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
